import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

export const FewItemsLeftIcon = (props) => (
    <Box as="span" width={1} height={1} bg="red.700" {...props} />
)

export const FewItemsLeftMessage = ({containerProps, textProps}) => (
    <Flex alignItems="center" justify="flex-start" gap={1} mt="8px" {...containerProps}>
        <FewItemsLeftIcon data-testid="few-items-left-icon" />
        <Text color="black" fontSize="xs" fontWeight={400} {...textProps}>
            <FormattedMessage id="product.few_left" defaultMessage="Few Left" />
        </Text>
    </Flex>
)

FewItemsLeftMessage.propTypes = {
    containerProps: PropTypes.object,
    textProps: PropTypes.object,
}
